// Lib
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, Middleware } from 'redux';

// Config
import getClientConfig from '../../../utils/getClientConfig';

// Utils
import { createLogger } from '../../../../node_module_clones/redux-logger/src';
import { isLoggerDebugEnabled, LoggerComponents } from '../../../logger';
import { isGlobalDebugEnabled } from '../../../debug/debugUtil';
import rootHotTableStoreReducer from './reducers/rootHotTableStoreReducer';

// Store
import addStateToWindowMiddleware from '../../../store/addStateToWindowMiddleware';

// Types
import { HotTableStoreActions } from './hotTableStoreTypes';
import { DEBUG_LEVEL } from '../../../../../config/configConstants';

// Actions to filter from the logger
export const LOG_FILTER_ACTIONS: Partial<Record<HotTableStoreActions['type'], number>> = {
    SET_ACTIVE_TABLE: DEBUG_LEVEL.FINE,
};

/**
 * The initial entry point to the Tiptap editor store.
 */
export default function configureHotTableStore(initialState = undefined) {
    const middlewareList: Middleware[] = [thunk];
    const config = getClientConfig();

    if (isLoggerDebugEnabled(LoggerComponents.REDUX_LOG_TABLE)) {
        const filteredActions = Object.entries(LOG_FILTER_ACTIONS)
            .filter(([logName, logLevel]) => logLevel >= (config.debugLevel as number))
            .map(([logName]) => logName);

        middlewareList.push(
            createLogger({
                // @ts-ignore TS can't infer the types correctly
                predicate: (_, action) => filteredActions.indexOf(action.type) === -1,
                collapsed: true,
                duration: true,
                timestamp: false,
                colors: {
                    title: () => 'blueviolet',
                },
            }) as Middleware,
        );
    }

    if (isGlobalDebugEnabled()) {
        middlewareList.push(addStateToWindowMiddleware('hot_table_'));
    }

    const middleware = applyMiddleware(...middlewareList);

    return createStore(rootHotTableStoreReducer, initialState, middleware);
}
